class evaluationsServices {
    constructor($resource,SERVICE_URL_CONSTANT) {
		const services = $resource(SERVICE_URL_CONSTANT.adminPanel +'/evaluations/:route',{},{
			getEvaluations:{
				method:'GET',
				params : {}
			},
			getTypeEvaluations:{
				method:'GET',
				params : {
					route: 'type-evaluation'
				}
			},
			getTypesGrades:{
				method:'GET',
				params : {
					route: 'types-grades'
				}
			},
			saveEvaluations:{
				method:'POST',
				params : {}
			},
			deleteEvaluations:{
				method:'POST',
				params: {
					route: 'delete-grades'
				}
			}
		});

		const servicesPeriod = $resource(SERVICE_URL_CONSTANT.adminPanel +'/period/:route',{},{
			getPeriod:{
				method:'GET',
				params : {}
			},
		});

		return {
			services : services,
			servicesPeriod: servicesPeriod
		};
	}
}

evaluationsServices.$inject=['$resource','SERVICE_URL_CONSTANT']

export default  angular.module('services.evaluationsServices', [])
.service('evaluationsServices', evaluationsServices)
.name;



// WEBPACK FOOTER //
// ./src/app/course-front/minor-half/minorHalfServices.js